// import 'virtual:windi-base.css';
import '@wahaha/wui-pro-components/dist/style.css';
import 'virtual:windi-components.css';
import 'virtual:windi-utilities.css';
import '/@/design/index.less';
import '/@/design/vxe/index.scss';
// Register icon sprite
import 'virtual:svg-icons-register';
import { createApp } from 'vue';
import App from './App.vue';
import { initSentry } from './sentry';
import { registerGlobComp } from '/@/components/registerGlobComp';
import { setupGlobDirectives } from '/@/directives';
import { setupI18n } from '/@/locales/setupI18n';
import { setupErrorHandle } from '/@/logics/error-handle';
import { initAppConfigStore } from '/@/logics/initAppConfig';
import { router, setupRouter } from '/@/router';
import { setupRouterGuard } from '/@/router/guard';
import { setupStore } from '/@/store';
// vxe-helpers
import { globalConfig as whhGlobalConfig } from '@wahaha/grid';
import '@wahaha/grid/es/style.css';
import { config } from '@wahaha/vxe-ext-core';
import 'ant-design-vue/dist/antd.less';
// import 'modern-css-reset';
import './vxe-helpers/formats';
import './vxe-helpers/renderer';
import './vxe-helpers/setup';
import { varients } from '/@/components/ProSelectTable/consts';
import '/@/style/index.scss';
import { defHttp } from '/@/utils/http/axios';

config.setup({
  idField: 'rowId',
  recordFields: {
    createdField: 'insertList',
    updatedField: 'updateList',
    removedField: 'deleteList',
  },
});

import { isUseSentry } from './utils/env';

// if (isDevMode()) {
//   import('ant-design-vue/es/style');
// }

async function bootstrap() {
  const app = createApp(App);

  if (isUseSentry()) {
    initSentry(app, router);
  }

  // Configure store
  // 配置 store
  setupStore(app);

  // Initialize internal system configuration
  // 初始化内部系统配置
  initAppConfigStore();

  // Register global components
  // 注册全局组件
  registerGlobComp(app);

  // Multilingual configuration
  // 多语言配置
  // Asynchronous case: language files may be obtained from the server side
  // 异步案例：语言文件可能从服务器端获取
  await setupI18n(app);

  // Configure routing
  // 配置路由
  setupRouter(app);

  // router-guard
  // 路由守卫
  setupRouterGuard(router);

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app);

  // Configure global error handling
  // 配置全局错误处理
  setupErrorHandle(app);

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();

  app.mount('#app');
  whhGlobalConfig.setConfig({ http: defHttp, varients });
}
bootstrap();
